import { handlePostRequest } from ".";
import { URI } from "../../constants/URI";

export const getSalesByProduct = async (body) => {
    const res = await handlePostRequest(URI.sales_by_product, body, {
        loading: false,
        toast: false
    });
    return res;
};

export const getSalesByCustomer = async (body) => {
    const res = await handlePostRequest(URI.sales_by_customer, body, {
        loading: false,
        toast: false
    });
    return res;
};

export const getSalesBySalesRep = async (body) => {
    const res = await handlePostRequest(URI.sales_by_salesrep, body, {
        loading: false,
        toast: false
    });
    return res;
};

export const getSalesByProductDetails = async (body) => {
    const res = await handlePostRequest(URI.sales_by_product_details, body, {
        loading: false,
        toast: false
    });
    return res;
};

export const getSalesByCustomerDetails = async (body) => {
    const res = await handlePostRequest(URI.sales_by_customer_details, body, {
        loading: false,
        toast: false
    });
    return res;
};

export const getSalesBySalesRepDetails = async (body) => {
    const res = await handlePostRequest(URI.sales_by_salesrep_details, body, {
        loading: false,
        toast: false
    });
    return res;
};

export const getSalesByPostcode = async (body) => {
    const res = await handlePostRequest(URI.sales_by_postcode, body, {
        loading: false,
        toast: false
    });
    return res;
}

export const getSalesByPostcodeDetailsProduct = async (body) => {
    const res = await handlePostRequest(URI.sales_by_postcode_details_product, body, {
        loading: false,
        toast: false
    });
    return res;
}

export const getSalesByPostcodeDetailsCustomer = async (body) => {
    const res = await handlePostRequest(URI.sales_by_postcode_details_customer, body, {
        loading: false,
        toast: false
    });
    return res;
}

export const getLeadsReport = async (body) => {
    const res = await handlePostRequest(URI.leads_report, body, { toast: false, loading: false });
    return res;
}

export const getLeadsReportDetails = async (body) => {
    const res = await handlePostRequest(URI.leads_report_details, body, {
        loading: false,
        toast: false
    });
    return res;
}

export const getCreditReport = async (body) => {
    const res = await handlePostRequest(URI.credit_report, body, { toast: false, loading: false });
    return res;
}
export const getLeadCheckinsReport = async (body) => {
    const res = await handlePostRequest(URI.lead_checkins_report, body, { toast: false, loading: false });
    return res;
}

export const getLeadCheckinsReportDetails = async (body) => {
    const res = await handlePostRequest(URI.lead_checkins_report_details, body, {
        loading: false,
        toast: false
    });
    return res;
}
